
















































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Business, ToggleCompanyStatusPayload } from "../types";
import { namespace } from "vuex-class";
import { AxiosResponse } from "node_modules/axios";

const BusinessNamespace = namespace("business");

@Component({
  components: {},
})
export default class StatusBanner extends Vue {
  @Prop({ default: false }) readonly isCompleted!: boolean;
  @Prop({ default: false }) readonly isPending!: boolean;
  @Prop({ default: false }) readonly isApproved!: boolean;
  @Prop({ default: false }) readonly isRejected!: boolean;
  @Prop() readonly currentBusiness!: Business;

  @BusinessNamespace.Action("toggleCompanyStatusPayload")
  toggleCompanyStatusPayload!: (
    payload: ToggleCompanyStatusPayload
  ) => Promise<AxiosResponse>;

  isBeingRejected = false;
  isBeingApproved = false;

  toggle(action: string) {
    if (action === "deny") this.isBeingRejected = true;
    else if (action === "approve") this.isBeingApproved = true;
    try {
      this.toggleCompanyStatusPayload({
        id: this.currentBusiness.id!,
        action,
        onError: this.showErrorNotification,
      }).then(() => {
        this.isBeingApproved = false;
        this.isBeingRejected = false;
      });
    } catch (e) {
      console.log(e);
    }
  }

  showErrorNotification(message: string): void {
    this.$notify({
      group: "error",
      title: "Error",
      text: message,
    });
  }
}
